import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import getLoyaltyAccountRegion from './getLoyaltyAccountRegion'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/agentHubSelectors'

/**
 * We compare the the current region code with the user's loyalty account region.
 * The program should largely be disabled when they don't match and we want to prompt them to switch
 * to their loyalty account region.
 * @NOTE A user has both a region associated with their main brand / auth account and another region associated with their loyalty account.
 * These can be different.
 */
const getIsCurrentRegionUserLoyaltyRegion = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => getLoyaltyAccountRegion(state),
  (state: App.State) => state.geo.currentRegionCode,
  (isEnabled, userLoyaltyAccountRegion, currentRegion): boolean => {
    if (isLuxLoyaltyEnabledInAgentHub) return true
    if (!isEnabled || !userLoyaltyAccountRegion) return false
    return currentRegion === userLoyaltyAccountRegion
  },
)

export default getIsCurrentRegionUserLoyaltyRegion
